/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ScreeningTypeEnum {
    IspisRzp = 'ISPIS_RZP',
    IspisObchr = 'ISPIS_OBCHR',
    IspisOsobacuzk = 'ISPIS_OSOBACUZK',
    IspisCee = 'ISPIS_CEE',
    MvcrIdentityCard = 'MVCR_IDENTITY_CARD',
    IsirInsolvency = 'ISIR_INSOLVENCY',
    TransactionScoring = 'TRANSACTION_SCORING',
    ZobiOsobacuzk = 'ZOBI_OSOBACUZK'
}

export function ScreeningTypeEnumFromJSON(json: any): ScreeningTypeEnum {
    return ScreeningTypeEnumFromJSONTyped(json, false);
}

export function ScreeningTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreeningTypeEnum {
    return json as ScreeningTypeEnum;
}

export function ScreeningTypeEnumToJSON(value?: ScreeningTypeEnum | null): any {
    return value as any;
}

